function setFichesMetierHeight() {
  const cards = $(".fichesmetier  .fichesmetier_list .fichesmetier_lastNews-link .fichesmetier_lastNews");
  let height = 0;

  cards.css("height", "fit-content");

  cards.each(function () {
    if ($(this).innerHeight() > height) {
      height = $(this).innerHeight();
    }
  });

  cards.css("height", `${height}px`);

  setTimeout(() => {
    setFichesMetierHeight();
  }, 100);
}

jQuery(document).ready(function () {
  setFichesMetierHeight();

  if ($(".fichesmetier").length > 0) {
    var allReal = $(".fichesmetier_lastNews-link");
    var itemToDisplay = 9;
    var thematique = $(".fichesmetier_filterItem:first-child").attr("id");
    var allItem = allReal.length;
    $(".fichesmetier_filterItem:first-child").toggleClass(
      "fichesmetier_filterItem-active"
    );
    function find3n() {
      // $(".fichesmetier_lastNews-link:visible:nth-of-type(3n)");
      var test = $(".fichesmetier_lastNews-link");
      if (test.is(":visible")) {
        console.log("visible");
      }
    }
    find3n();

    function defineCardToDisplay() {
      if (allItem > itemToDisplay) {
        $(".fichesmetier_showMore").show();
      }

      $(".fichesmetier_lastNews-link:lt(" + itemToDisplay + ")").show();

      $(".fichesmetier_showMore").click(function () {
        itemToDisplay = itemToDisplay + 3;

        if (thematique == undefined) {
          $(".fichesmetier_lastNews-link:lt(" + itemToDisplay + ")").show();
        } else {
          $(
            ".fichesmetier_lastNews-" +
              thematique +
              ":lt(" +
              itemToDisplay +
              ")"
          ).show();
        }
        if (allItem <= itemToDisplay) {
          $(".fichesmetier_showMore").hide();
        }
      });
    }
    defineCardToDisplay();

    function changeItemToDisplay() {
      allReal.hide();
      var count = 0;
      allReal.each(function (index) {
        if ($(this).data(thematique)) {
          if (count < itemToDisplay) {
            $(this).show();
            count++;
          }
        }
      });
    }

    $(".fichesmetier_filterItem").click(function () {
      $(".fichesmetier_filterItem").removeClass(
        "fichesmetier_filterItem-active"
      );
      $(this).toggleClass("fichesmetier_filterItem-active");
      thematique = $(this).attr("id");
      var thematiqueItem = $(".fichesmetier_lastNews-" + thematique).length;
      allItem = thematiqueItem;
      if (thematiqueItem <= itemToDisplay) {
        $(".fichesmetier_showMore").hide();
      } else {
        $(".fichesmetier_showMore").show();
      }
      changeItemToDisplay();
    });
    changeItemToDisplay();
  }
});
